/* CUSTOM (Shopify-Session)
 * glaze-picker.js — AJAX-Tausch des Geschwister-Produkts ohne Page-Reload.
 *
 * Klick auf einen Swatch (.article-siblings__swatch) -> fetch der Ziel-Produktseite,
 * <product-info>-Block extrahieren und in-place ersetzen. URL via history.pushState.
 * Falls fetch fehlschlägt: Fallback auf normale Navigation (Browser folgt dem Link).
 */
(function () {
  if (customElements.get('glaze-picker')) return;

  class GlazePicker extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    async onClick(event) {
      const link = event.target.closest('a.article-siblings__swatch');
      if (!link || !this.contains(link)) return;
      if (link.hasAttribute('aria-current')) {
        event.preventDefault();
        return;
      }

      const productInfo = this.closest('product-info');
      if (!productInfo) return;

      event.preventDefault();
      productInfo.classList.add('is-glaze-loading');

      const targetUrl = new URL(link.href, window.location.origin);

      // Quantity-State merken (auf neuen max clampen)
      const oldQtyInput = productInfo.querySelector('.quantity__input');
      const preservedQty = oldQtyInput ? parseInt(oldQtyInput.value, 10) : null;

      try {
        const response = await fetch(targetUrl.toString(), { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('HTTP ' + response.status);
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newProductInfo = doc.querySelector('product-info');
        if (!newProductInfo) throw new Error('product-info not found in response');

        history.pushState({ glazePicker: true }, '', targetUrl.pathname + targetUrl.search);
        productInfo.replaceWith(newProductInfo);

        if (document.title && doc.title) document.title = doc.title;

        // Quantity-State zurückschreiben (clamped auf neuen max)
        if (preservedQty && preservedQty > 1) {
          const newQtyInput = newProductInfo.querySelector('.quantity__input');
          if (newQtyInput && !newQtyInput.disabled) {
            const max = parseInt(newQtyInput.getAttribute('max'), 10);
            const clamped = max ? Math.min(preservedQty, max) : preservedQty;
            newQtyInput.value = clamped;
            newQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }

        newProductInfo.scrollIntoView({ block: 'nearest', behavior: 'instant' });
      } catch (err) {
        console.error('[CUSTOM glaze-picker]', err);
        window.location.href = link.href;
      }
    }
  }

  customElements.define('glaze-picker', GlazePicker);
})();
